import React, { useState, useEffect } from 'react';
import MainContent from './MainContent';

function Parenting() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const loadParenting = async () => {
      try {
        const module = await import('../data/parenting.json');
        setContent(module.default);
      } catch (error) {
        console.error("Failed to load parenting:", error);
        setContent({
          name: 'Parenting',
          description: 'Content temporarily unavailable',
          sections: []
        });
      }
    };

    loadParenting();
  }, []);

  if (!content) return <div>Loading...</div>;

  return <MainContent content={content} />;
}

export default Parenting;
